<template>
  <div class="goal-inline clearfix" v-if="goalIsReady" :class="{ 'is-selected' : isSelected }">
    <a href="#" @click.prevent="onSelect">
      <img :src="imageSource" :style="imageCSS" class="goal-inline-image" />
    </a>
    <span class="goal-inline-text" :style="textCSS">{{goalMetaData.cachedName}}</span>
    <font-awesome-icon icon="trash-alt" class="taskicon" @click.prevent="onRemove" v-if="showDelete" />
    <font-awesome-icon icon="wrench" class="taskicon" @click.prevent="onEdit" />
  </div>
</template>

<script>
import Color from 'color';

export default {
  props: {
    goal_id: {},
    isSelected: {
      default: false
    },
    showDelete: {
      default: false
    }
  },
  data: () => ({
  }),
  computed: {
    // ...mapGetters("goal", [
    //   "goal_list_state",
    //   // "goal_by_id",
    //   // "goal_is_ready"
    // ]),

    publicGoalData() {
      return this.$models.userGoalSettings.getNode( this.goal_id );
    },

    goalIsReady( goal_id ) {
      return this.publicGoalData.$ready
    },

    // goalIsReady() {
    //   return this.goal_is_ready( this.goal_id );
    // },
    //
    // publicGoalData() {
    //   return this.goal_by_id( this.goal_id );
    // },

    goalMetaData() {
      return this.$models.goalMeta.getNode( this.goal_id );
      // if ( this.goalIsReady ) {
      //   let goal = this.goal_list_state[ this.goal_id ]
      //   return goal.meta ? { ...goal.meta, id: this.goal_id } : null;
      // }
      // return null;
    },

    textCSS() {
      let userGoal = this.goalMetaData;
      return {
        fontFamily: userGoal.graphicalRepresentation.headline.fontFamily,
      }
    },

    imageSource() {
      let publicGoal = this.publicGoalData;
      return publicGoal ? publicGoal.picture : '';
    },

    imageCSS() {
      let scale = (1 / 5);
      let userGoal = this.goalMetaData;
      let shadowOffsetX = 0;
      let shadowOffsetY = 0;
      if ( userGoal.graphicalRepresentation.shadowOffset ) {
        shadowOffsetX   = userGoal.graphicalRepresentation.shadowOffset.x * scale;
        shadowOffsetY   = userGoal.graphicalRepresentation.shadowOffset.y * scale;
      }
      let shadowColor   = userGoal.graphicalRepresentation.shadowColor;
      let shadowBlur    = userGoal.graphicalRepresentation.shadowBlur * scale;
      let shadowOpacity = userGoal.graphicalRepresentation.shadowOpacity;
      let shadowColorRGBA = Color( shadowColor ).alpha( shadowOpacity );
      return {
        width:     '100px',
        boxShadow: `${shadowOffsetX}px ${shadowOffsetY}px ${shadowBlur}px ${shadowColorRGBA}`
      };
    },
  },
  methods: {
    onRemove() {
      console.log("todo");
    },

    onEdit() {
      this.$root.showUpdateModal('goal', {
        goalId: this.goal_id
      });
    },

    onSelect() {
      this.$emit('select', this.goal_id);
    }
  }
}
</script>

<style>
.goal-inline {
  border: 1px solid #dcdfe6;
  padding: 5px;
  margin: 5px 0;
}
.goal-inline .taskicon {
  float: right;
  margin: 5px;
  cursor: pointer;
}
.goal-inline-text {
  font-weight: bold;
  margin: 0.5em;
  font-size: 14pt;
}
.goal-inline-image:hover {
  /* border: 2px solid black; */
  opacity: 0.5;
}
.goal-inline.is-selected {
  border-left: 10px solid #dcdfe6;
}
</style>
